const readJsonFile = (filename) => {
    fetch(filename)
        .then(response => response.json())
        .then(obj => console.log(obj))
}
function readTextFile(file, callback) {
    let rawFile = new XMLHttpRequest();
    rawFile.overrideMimeType("application/json");
    rawFile.open("GET", file, true);
    rawFile.onreadystatechange = function() {
        if (rawFile.readyState === 4 && rawFile.status == "200") {
            callback(rawFile.responseText);
        }
    }
    rawFile.send(null);
}
//This function works also for loading a .html or .txt files, by overriding the mime type parameter to "text/html", "text/plain" etc.

export { readTextFile, readJsonFile }